import { 
    STUDY_INITIALIZE_WORKFLOW, 
    STUDY_ON_FIELD_CHANGE,
} from '../actions/workflow';
 

export function initializeStudyWorkflow(state, action) {
    if(!action || action.type !== STUDY_INITIALIZE_WORKFLOW) {
        return state;
    }

    return {
        ...state,
        study: {
            ...state.study,
            fields: {},
            data: {}
        }
    };
}


export function setField(state, action) {
    if(!action || action.type !== STUDY_ON_FIELD_CHANGE) {
        return state;
    }

    const { fieldName, fieldValue } = action.payload;

    return {
        ...state,
        study: {
            ...state.study,
            fields: {
                ...state.study.fields,
                [fieldName]: fieldValue
            },
        }
    };
}


